import { createContext, useState, useEffect, ReactNode } from "react";
import { dashboardAxios } from "APIs";
import axios from "axios";

interface dashboardData {
    isLoading: boolean;
    status: number | null;
    error: string | null;
    data: any;
  }

interface DashboardContextProps {
  dashBoardData: dashboardData;
 
}
const DASHBOARD_DATA_MODAL = {
    isLoading: true,
    status: 0,
    error: null,
    data: []
  }

export const DashboardContext = createContext<DashboardContextProps | undefined>(
  undefined
);

export const DashboardProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [dashboardData, setDashboardData] = useState<dashboardData>(DASHBOARD_DATA_MODAL);
 
  useEffect(() => {
  const currentDate = new Date().toISOString().split("T")[0];

  const fetchData = async () => {
    try {
      const response = await dashboardAxios.get("/admin/dashboard", {
        headers: {
          detailsDate: currentDate,
        },
      });

      const {
        data: { error, data },
        status,
      } = response;

      setDashboardData({
        isLoading: false,
        status,
        error,
        data: data.adminDashboard,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);

      setDashboardData((prev) => ({
        ...prev,
        isLoading: false,
      }));

      if (axios.isAxiosError(error) && error.response?.status === 401) {
        localStorage.clear();
      }
    }
  };

  fetchData();
}, []);


  return (
    <DashboardContext.Provider value={{ dashBoardData:dashboardData}}
    >
      {children}
    </DashboardContext.Provider>
  );
};
